import Vue from 'vue';

const mutations = {
  setGSGo(state, obj) {
    state.GSGo.reportType = obj.reportType;
    state.GSGo.locationId = obj.locationId;
    state.GSGo.stratCatId = obj.stratCatId;
    state.GSGo.yearId = obj.yearId;
  },
  setCompareColumns(state, arr) {
    state.compareColumns = arr;
  },
  setCRDataRaw(state, arr) {
    state.crDataRaw = arr;
  },
  setShowCategoryId(state, obj) {
    Vue.set(state.showCategoryIds, obj.id, obj.show);
  },
  setShowCategoryIds(state, obj) {
    state.showCategoryIds = obj;
  },
  setLoadingCRData(state, value) {
    state.flags.loadingCRData = value;
  },
  setShowReportBody(state, value) {
    state.flags.showReportBody = value;
  },
  setShowReportOptions(state, value) {
    state.flags.showReportOptions = value;
  },
  setGeneratingPdf(state, value) {
    state.flags.generatingPdf = value;
  },
  setSearchString(state, value) {
    state.searchString = value;
  },
  setReportOptionsGo(state, obj) {
    state.reportOptionsGo.categoryFilterId = obj.categoryFilterId;
    state.reportOptionsGo.stratFilterId = obj.stratFilterId;
    state.reportOptionsGo.showCI = obj.showCI;
    state.reportOptionsGo.showWN = obj.showWN;
    state.reportOptionsGo.hideMissingDataRows = obj.hideMissingDataRows;
  },
  clearColumnsSearchAndReportOptions(state) {
    state.compareColumns = [];
    state.flags.showReportBody = false;
    state.searchString = '';
    state.flags.showReportOptions = false;
    state.showCategoryIds = {};
    state.reportOptionsGo = {
      categoryFilterId: '',
      stratFilterId: '',
      showCI: true,
      showWN: true,
      hideMissingDataRows: false,
    };
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/CR/mutations.js